import { AuctionWithRevenue } from '@/app/api/revenue/route';
import RecentAuctionRow from '@/app/RecentAuctionRow';
import { formatCurrency } from '@/lib/utils';
import { Flex, Text } from '@radix-ui/themes';
import Link from 'next/link';
import React from 'react';

interface RecentAuctionsProps {
    auctions: AuctionWithRevenue[];
    totalRevenue: number;
}

const RecentAuctions = ({ auctions, totalRevenue }: RecentAuctionsProps) => {
    return (
        <Flex direction="column" className="w-2/5 border rounded-xl p-6 pb-3 shadow">
            <Link href="/admin/auctions">
                <Flex direction="column">
                    <Text className="text-lg font-semibold">
                        Recent Auctions
                    </Text>
                    {totalRevenue > 0 && 
                        <Text className="text-zinc-500">Your {auctions?.length} most recent auctions have generated
                                {` `}{formatCurrency(totalRevenue, true, 2)}.</Text>
                    }
                </Flex>
            </Link>
            {auctions.length > 0 ? (
                <Flex direction="column" gap="1" className="mt-3">
                    {auctions?.map((auction, idx) => (
                    <RecentAuctionRow key={idx} auction={auction} />
                    ))}
                </Flex>
            ) : (
                <Flex direction="column" align="center" justify="center"
                    className="flex-grow w-full h-full">
                    <Text className="text-zinc-500">No recent auctions</Text>
                </Flex>
            )}
        </Flex>
    );
};

export default RecentAuctions;



